import { useCallback, useEffect, useState } from 'react';
import {storage} from '../utils/storage';
import {MessageProps} from "../types/messages";
import {getSetting} from "../utils/settings";

export function createHistoryState() {
    const [state, setHistory] = useState<MessageProps[]>(() =>
        storage.load()
    );

    const addMessage = useCallback((message: MessageProps) => {
        setHistory((prev) => [
            ...prev,
            {
                ...message,
                timestamp: Date.now(),
            },
        ]);
    }, []);

    const clearHistory = useCallback( () => {
        storage.clear();
        setHistory([]);
    }, []);

    const getMessages = useCallback((): MessageProps[] => {
        return state;
    }, [state]);

    const hasMessages = useCallback((): boolean => {
        return state.length > 0
    }, [state]);

    const reachedLimit = useCallback((): boolean => {
        const limit = getSetting( 'chat.messages_limit' );
        const botMessages= state.filter( ( message ) => message.sender === 'bot' );

        return botMessages.length >= limit;
    }, [state]);

    useEffect(() => {
        storage.save(state);
    }, [state]);

    return {
        state,
        addMessage,
        getMessages,
        hasMessages,
        clearHistory,
        reachedLimit,
    };
}
